/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';

Sentry.init({
  dsn: "https://54c63eb1d06fc7dea853441139f9481c@o4510393263063040.ingest.de.sentry.io/4510425594134608",
  sendDefaultPii: true,
  environment: environment.env
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
